export const GET_ALL_ORG_PROJECTS = "GET_ALL_ORG_PROJECTS";
export const SET_PROJECTS = "SET_PROJECTS";
export const RESET_PROJECTS = "RESET_PROJECTS";
export const SET_PROJECTS_COUNT = "SET_PROJECTS_COUNT";
export const GET_PROJECT_DETAIL = "GET_PROJECT_DETAIL";
export const GET_PROJECT_LINKS = "GET_PROJECT_LINKS";
